<template>
    <button v-if="product.canUploadFiles && product.getOption('product-creation-workshop')" class="btn btn-warning"
            v-tooltip="$t('ProductCreationWorkshopButton.launchWorkshop')"
            @click="$emit('show-product-creation-workshop-modal', product)">
        <slot name="text"/>
    </button>
</template>

<script>
import Product from "@/classes/Product";

export default {
    name: "ProductCreationWorkshopButton",
    props: {
        product: {
            type: Product,
            required: true,
        },
        showTooltip: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>

</style>